
$('#language_switch').on('change', function(){
  var selected = $('#language_switch option:selected').val();
  window.location.href = "?locale=" + selected;
});
